var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "22px",
  height: "22px",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "Icons/circle",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.84054 3.83969C5.73935 1.94088 8.31468 0.874146 11 0.874146C13.6853 0.874146 16.2606 1.94088 18.1595 3.83969C20.0583 5.7385 21.125 8.31383 21.125 10.9991C21.125 13.6845 20.0583 16.2598 18.1595 18.1586C16.2606 20.0574 13.6853 21.1241 11 21.1241C8.31468 21.1241 5.73935 20.0574 3.84054 18.1586C1.94174 16.2598 0.875 13.6845 0.875 10.9991C0.875 8.31383 1.94174 5.7385 3.84054 3.83969ZM11 2.37415C8.71251 2.37415 6.51871 3.28285 4.9012 4.90035C3.2837 6.51785 2.375 8.71165 2.375 10.9991C2.375 13.2866 3.2837 15.4804 4.9012 17.0979C6.51871 18.7154 8.71251 19.6241 11 19.6241C13.2875 19.6241 15.4813 18.7154 17.0988 17.0979C18.7163 15.4804 19.625 13.2866 19.625 10.9991C19.625 8.71165 18.7163 6.51785 17.0988 4.90035C15.4813 3.28285 13.2875 2.37415 11 2.37415Z",
  fill: "#676C6E"
}))));
export { SvgCircle as ReactComponent };
export default __webpack_public_path__ + "images/circle.svg";